import { Switch as BaseSwitch } from "@base-ui-components/react/switch";
import type { FC } from "react";
import { cn } from "@/lib/cn";

type SwitchProps = {
  id?: string;
  labelId?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
};

export const Switch: FC<SwitchProps> = ({
  id,
  labelId,
  checked,
  onCheckedChange,
  disabled,
}) => (
  <BaseSwitch.Root
    id={id}
    aria-labelledby={labelId}
    checked={checked}
    onCheckedChange={onCheckedChange}
    disabled={disabled}
    className={cn(
      "relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      checked ? "bg-foreground" : "bg-muted",
    )}
  >
    <BaseSwitch.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform",
        checked
          ? "translate-x-6 bg-background"
          : "translate-x-0.5 bg-foreground",
      )}
    />
  </BaseSwitch.Root>
);
